import React, { useEffect } from "react";
import styles from "./DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import CompareContainer2 from "../../components/CompareContainer/CompareContainer2";
import TypeOfRequirements from "../../components/TypeOfRequirements";
import MatchingMortgages2 from "../../components/MatchingMortgages/MatchingMortgages2";
import NewsContainer from "../../components/NewsContainer";
import LoanApplication2 from "../../components/LoanApplication/LoanApplication2";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";

const DevelopmentFinanceBlogs2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Development Finance" />
      <CompareContainer2 title="Development Finance" />
      <TypeOfRequirements title="Development Finance" />
      <MatchingMortgages2 title="Development Finance" />
      <NewsContainer title="Development Finance" />
      <LoanApplication2 title="Development Finance" />
      <TestimonialsContainer title="Development Finance" />
      <Footer title="Development Finance" />
    </div>
  );
};

export default DevelopmentFinanceBlogs2;
